// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectYTMMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_YTM_RESPONSE);
        this.InstrumentID = null;
        this.RouteId = null;
        this.YieldRate = null;
    }
}
